<div adaptToolbarContent
     alignment="right">
    <adapt-menu [items]="tourMenuItems"
                [showOnHover]="true"
                data-test="personal-dashboard-tour"
                data-tour="personal-dashboard-tour"></adapt-menu>
</div>

<div adaptToolbarContent
     [ordinal]="1000">
    <a [routerLink]="personalConfigLink$ | async"
       adaptButton="configureLink"
       adaptTooltip="Go to personal configuration"></a>
</div>

<adapt-activity-page-content class="h-100">
    <div activity-page-before
         class="px-2 ctas">
        <adapt-embed-shell-tour-prompt-dashboard-element [person]="person$ | async"></adapt-embed-shell-tour-prompt-dashboard-element>
        <adapt-ai-tour-prompt-dashboard-element *adaptIfFeatureActive="FeatureName.PlatformAI"></adapt-ai-tour-prompt-dashboard-element>
        <adapt-theme-prompt-dashboard-element [person]="person$ | async"></adapt-theme-prompt-dashboard-element>
    </div>
</adapt-activity-page-content>
